import "./style.scss";
import * as React from "react";
import _ from "lodash";
import { Icon } from "antd";
import { SimplePieChart } from "../../../../core/Chart";
import { processPieChartData } from "../../../../core/Chart/common/utils";
import { WarningBar } from "../../../../common/components/WarningBar";
import { formatXAxisLabel } from "../../../constants";

interface MetricGroupPieChartProps {
  group_by: string;
  metric: string;
  data: any[];
}

export class PieChart extends React.Component<MetricGroupPieChartProps, {}> {
  render() {
    let { group_by, metric, data } = this.props;

    const processedData = processPieChartData(data, group_by, metric);
    const hiddenPublications = processedData.length != data.length;

    //PURE CSS uses flex box which interferes with recharts' resizableContainer's onscroll width recalculations
    //https://github.com/recharts/recharts/issues/172
    // to work around set width:99%
    return (
      <div className="analytics-pie-chart">
        {hiddenPublications && (
          <WarningBar icon="exclamation">
            {formatXAxisLabel(group_by)} without data for the selected metric
            are not shown in the pie chart.
          </WarningBar>
        )}
        {processedData &&
        ((processedData.length > 0 && processedData[0][metric]) ||
          processedData.length > 1) ? (
          <SimplePieChart
            containerProps={{
              height: 450,
              width: "99%"
            }}
            chartProps={{
              data: processedData,
              valueKey: metric,
              groupingKey: group_by
            }}
          />
        ) : (
          <div className="null-text">
            <span className="analytics-null-chart">
              There's no data available for the selected dropdowns.
              <br />
              Try changing the dropdowns to view data.
            </span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/PieChart/index.tsx